export const ERRORS = {
    MISSING_ROLLOUT_NAME_ARGUMENT: 'Must provide a rollout name to check',
    MISSING_IDENTIFIER_ARGUMENT: 'Must provide a user identifier (userId or uGuid)',
    MISSING_SERVICE_URL: 'Must provide "serviceUrl" in rollout initialization (kubernetes env variable)',
    MISSING_APP_NAME: 'Must provide "appName" in rollout initialization',
    INVALID_CACHE_TTL_OPTION: 'cacheTtl must be an integer greater than 0',
    INVALID_FETCH_TIMEOUT_OPTION: 'fetchTimeout must be an integer >= than 0',
    INVALID_REFRESH_TIMEOUT_OPTION: 'refreshTimeout must be an integer >= than 0',
    UNDEFINED_ROLLOUT_DATA: 'Rollout data is undefined',
    NOT_INITIALIZED: 'Must call "initialize" function and supply "appName" prior to using rollout.',
};

export const CACHE_TTL_DEFAULT = 60000; // milliseconds (= 1 minute)

export const FETCH_TIMEOUT_DEFAULT = 300; // milliseconds (= 0.3 second)

export const REFRESH_TIMEOUT_DEFAULT = 0; // milliseconds (no timeout by default)

export const THROTTLE_WINDOW = 1000; // milliseconds (= 1 second)
